import type { OrderStatus } from '../types/api.types'

// Shared by the Orders board and the conversation drawer, which shows the order
// a call produced. Two copies of the palette would drift the moment one of them
// gained a status.

export const STATUS_LABEL: Record<OrderStatus, string> = {
  PLACED: 'Placed',
  IN_KITCHEN: 'In kitchen',
  READY: 'Ready',
  SERVED: 'Served',
  BILLING: 'Billing',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
}

export const STATUS_STYLE: Record<OrderStatus, string> = {
  PLACED: 'bg-amber-100 text-amber-800',
  IN_KITCHEN: 'bg-blue-100 text-blue-800',
  READY: 'bg-green-100 text-green-800',
  SERVED: 'bg-teal-100 text-teal-800',
  BILLING: 'bg-purple-100 text-purple-800',
  COMPLETED: 'bg-gray-100 text-gray-600',
  CANCELLED: 'bg-red-100 text-red-700',
}
